<section class="py-5">
  <div class="container">
    <div class="bg-grey border rounded p-4 p-md-5">
      <div class="row align-items-center mb-4">
        <div class="col-md-7">
          <common-brand-logo class="d-block mb-1" product="Connect"></common-brand-logo>
          <h2 class="text-uppercase font-weight-bold mb-0 fs-28 text-dark">
            Put your machines, trucks &amp; crew <span class="text-green">to work.</span>
          </h2>
        </div>
        <div class="col-md-5 mt-3 mt-md-0">
          <div class="d-flex flex-wrap align-items-center justify-content-md-end">
            <a routerLink="/connect" class="btn btn-success">
              Explore Connect <i class="icon-arrow-right ml-2"></i>
            </a>
            <button
              type="button"
              class="btn py-2 px-3 b-grey d-inline-flex align-items-center ml-3"
              (click)="share()"
              aria-label="Share Rubbl Connect"
            >
              <i class="icon-share text-red mr-1" aria-hidden="true"></i>
              Share
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 mb-3 mb-md-0">
          <a
            routerLink="/machines"
            class="d-flex flex-column bg-white border rounded p-4 h-100 text-dark text-decoration-none"
          >
            <i class="icon-camera text-green fs-22 mb-2 d-inline-block"></i>
            <h3 class="h6 font-weight-bold mb-1">Earn with your machines</h3>
            <p class="font-weight-light mb-3 fs-14">Join the private backup fleet and get notified about nearby machine deals.</p>
            <span class="text-green font-weight-bold mt-auto">View &rsaquo;</span>
          </a>
        </div>
        <div class="col-md-4 mb-3 mb-md-0">
          <a
            routerLink="/hauling"
            class="d-flex flex-column bg-white border rounded p-4 h-100 text-dark text-decoration-none"
          >
            <i class="icon-truck text-green fs-22 mb-2 d-inline-block"></i>
            <h3 class="h6 font-weight-bold mb-1">Haul equipment</h3>
            <p class="font-weight-light mb-3 fs-14">Get notified about hauling jobs near you to bid on.</p>
            <span class="text-green font-weight-bold mt-auto">View &rsaquo;</span>
          </a>
        </div>
        <div class="col-md-4">
          <a
            routerLink="/service"
            class="d-flex flex-column bg-white border rounded p-4 h-100 text-dark text-decoration-none"
          >
            <i class="icon-wrench text-green fs-22 mb-2 d-inline-block"></i>
            <h3 class="h6 font-weight-bold mb-1">Service equipment</h3>
            <p class="font-weight-light mb-3 fs-14">Get matched with maintenance and repair work nearby.</p>
            <span class="text-green font-weight-bold mt-auto">View &rsaquo;</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
